/* VeeNourish rails: hide the prev/next arrow at either end of a carousel.
   Add-to-cart and arrow scrolling come from pm-home.js (data-pm-* hooks). */
(function () {
  if (window.VNHome) return;
  window.VNHome = true;

  function update(rail) {
    var track = rail.querySelector('[data-pm-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    rail.classList.toggle('is-start', track.scrollLeft <= 2);
    rail.classList.toggle('is-end', track.scrollLeft >= max);
  }

  function bind(rail) {
    if (rail.dataset.vnBound) return;
    rail.dataset.vnBound = '1';
    var track = rail.querySelector('[data-pm-track]');
    if (!track) return;
    track.addEventListener('scroll', function () { update(rail); }, { passive: true });
    window.addEventListener('resize', function () { update(rail); });
    update(rail);
  }

  function init(root) {
    (root || document).querySelectorAll('.vn-rail').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); document.querySelectorAll('.vn-rail').forEach(update); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
